var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-help"},[_c('div',{staticClass:"top-title"},[_vm._v("常见问题解答")]),_c('ul',{staticClass:"help-content"},[_vm._l((_vm.helpList),function(item){return [_c('li',{key:item.title,staticClass:"title"},[_vm._v(_vm._s(item.title))]),_c('p',{key:item.content,staticClass:"content"},[_vm._v(_vm._s(item.content))])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }